import React, { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import toast from "react-hot-toast";
import { BsCheck2Circle, BsCreditCard2Back, BsWallet2 } from "react-icons/bs";
import BoxShadow from "../../../Common/Components/BoxShadow";
import Loading from "../../../Common/Components/Loading";
import { useRenewall } from "./Hooks";

import walletImg from '../../../../App/assets/images/walletCont.png'
import cellphoneCont from '../../../../App/assets/images/cellphoneCont.png'
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import { sepMoney } from "../../../../Web/Common/Function";

const Index = ({ isApp }) => {
  const { renewwall, loading, data, cansel, setCansel, pay, btnloading, setPayType, payType, balance } = useRenewall();
  const [terms, setTerms] = useState(false);

  useEffect(() => {
    renewwall();
  }, []);
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | تمدید قراداد</title>
      </Helmet>
      {loading ? (
        <Loading count={1} col={12} height={300} />
      ) : (
        <div className={!isApp && "container"}>
          <BoxShadow className={isApp && "shadow-none py-2 px-0"}>
            <div className="row">
              {/* <div className="col-12">
                <h3>تمدید قراداد</h3>
              </div> */}
              <div className="col-12 mt-2">
                <p style={{ fontSize: "13px", marginBottom: "3px" }} className={isApp && "fw300"}>
                  تایم های زیر تایم های هقتگی قراداد شما هستند :
                </p>
                <p style={{ fontSize: "11px" }} className={isApp && "fw300 mt-3"}>
                  در صورتی که تمایل دارید تایمی را از قرارداد خود
                  <span style={{ color: "#E42A3F", display: "inline-block", margin: "0 3px" }}>حذف</span>
                  کنید آن
                  تایم یا تایم هارا انتخاب کرده سپس گزینه ی پرداخت را بزنید و در
                  غیر این صورت بدون انتخاب هیچ تایمی دکمه پرداخت را کلیک کنید!
                </p>
              </div>
            </div>
            <div className="mt-3">
              <div className="row">
                <Week isApp={isApp} data={data} cansel={cansel} setCansel={setCansel} />
              </div>
            </div>

            <div className={"border rounded p-2 d-flex alin-items-center " + (isApp ? "" : "mt-3")}>
              <input type="radio" id="gh1" onChange={(e) => setTerms(e.target.checked)} />
              <label for="gh1" className="mr-2 mb-0 ms-2">
                شرایط و قوانین مجموعه ورزشی می پذیرم.
              </label>
            </div>

            <div className={"mt-4 d-flex flex-wrap mx-auto "}
              style={{ maxWidth: isApp ? "400px" : "500px", width: "100%" }}>
              {/* {isApp && */}
              <div className="border rounded p-2 flex-column fw300 nfs-13 w-100">
                <p className={"mb-3 " + (!isApp && "mb-3 text-center border-bottom pb-2")}>شیوه پرداخت</p>

                <div className="d-flex align-items-center" style={{ opacity: payType == "wallet" && "0.5" }}>
                  <img className="ml-2 mb-2" src={cellphoneCont} width={22} height={22} />
                  پرداخت آنلاین
                  <BsCheck2Circle className={isApp && "mr-auto"} size={24} color={payType == "wallet" ? "#cecece" : "#E42A3F"}
                    style={{ marginRight: !isApp && "auto", marginLeft: !isApp && "30px" }}
                  />
                </div>

                <div className="d-flex align-items-center">
                  <img className="ml-2" src={walletImg} width={22} height={22} />
                  استفاده از اعتبار
                  <span className="nfs-10 nfc-5C5C5C mr-1">
                    موجودی  :
                    {balance == "loading"
                      ?
                      "در حال دریافت ..."
                      : <>{" "} {sepMoney(balance)} تومان </>
                    }
                  </span>
                  <FormGroup className={isApp && "mr-auto"} style={{ marginRight: !isApp && "auto" }}>
                    <FormControlLabel size="sm" control={<Switch defaultChecked />} checked={payType == "wallet"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setPayType("wallet")
                        }
                        else {
                          setPayType("gateway")
                        }
                      }} />
                  </FormGroup>
                </div>
              </div>
            
              <div className={"{d-flex justify-content-end col-12 mt-3 " + (isApp && "px-0")}
                onClick={() => {
                  if (terms) {
                    pay();
                  }
                  else {
                    toast.error("شرایط و قوانین مجموعه را تایید کنید");
                  }
                }
                }>
                <button className={"btn w-100 d-flex justify-content-center " + (isApp ? "btn-primary" : "btn-success")}>
                  {btnloading ? "درحال پردازش" : "ثبت و پرداخت"}
                </button>
              </div>
            </div>
          </BoxShadow>
        </div>
      )}
    </Fragment>
  );
};
const Week = ({ data, cansel, setCansel, isApp }) => {
  const convertDay = (day) => {
    switch (day) {
      case "Wednesday":
        return "چهارشنبه";
      case "Thursday":
        return "پنج شنبه";
      case "Friday":
        return "جمعه";
      case "Monday":
        return "دوشنبه";
      case "Tuesday":
        return "سه شنبه";
      case "Saturday":
        return "شنبه";
      case "Sunday":
        return "یک شنبه";
      default:
        break;
    }
  };
  return (
    <>
      {Object.keys(data).map((day) => {
        return (
          <>
            {data[day].length > 0 ? (
              <div className="col-12 mt-1">
                <div className={" " + (isApp && "mb-2")}>
                  <div className="">
                    <h5 className={isApp && "nfs-14"}>{convertDay(day) + " ها" + " :"}</h5>
                  </div>
                  <div className="">
                    <div className={isApp ? "d-flex justify-content-between" : "row"}>
                      {data[day].map((time) => {
                        return (
                          <Time
                            isApp={isApp}
                            data={time}
                            cansel={cansel}
                            setCansel={setCansel}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </>
        );
      })}
    </>
  );
};

const Time = ({ data, cansel, setCansel, isApp }) => {

  const toggle = (time) => {

    if (exist(time.id)) {
      setCansel([...cansel.filter((t) => t.id != time.id)]);
      toast.success("تایم انتخابی حذف شد");
    } else {
      if (time.reserve_details && time.reserve_time) {
        const {
          reserve_details: { timekey },
          reserve_time: { dayname },
          id,
        } = time;
        setCansel([...cansel, { timekey, dayname, id }]);
        toast.success("تایم انتخابی اضاف شد");
      }
    }
  };
  const exist = (id) => {
    let res = false;

    [...cansel].map((time) => {
      if (time.id == id) {
        res = true;
      }
    });
    return res;
  };
  return (
    <div className={!isApp && "col-md-3"}
      style={{
        cursor: "pointer",
        border: isApp ? exist(data.id) ? "1px solid #E42A3F" : "1px solid gray" : exist(data.id) ? "1px solid red" : "1px dashed black",
        borderRadius: isApp && "5px",
        padding: isApp && "5px",
        flex: isApp && "0 0 45%",
        marginBottom: isApp && "10px"
      }}
      onClick={() => toggle(data)}>
      <p className={"text-center " + (isApp && "nfs-12 fw300")}>
        ساعت شروع :{data.reserve_time.start}
      </p>
      <p className={"text-center " + (isApp && "nfs-12 fw300")}>
        ساعت پایان : {data.reserve_time.end}
      </p>
    </div>
  );
};
export default Index;
